import Mock from 'mockjs'
import account from './account'
import menu from './menu'
import role from './role'

Mock.setup({
    timeout: '350-600'
})

// //账号
// Mock.mock(/\/account\/login_user_info/, 'post', account.login_user_info);
// Mock.mock(/\/account\/captcha/, 'post', account.captcha);
// Mock.mock(/\/account\/login/, 'post', account.login);
// Mock.mock(/\/account\/logout/, 'post', account.logout);
// Mock.mock(/\/account\/modify_pwd/, 'post', account.modify_pwd);
//
// //账号组
// Mock.mock(/\/account_group\/query/, 'post', account_group.query);
//
// //菜单
// Mock.mock(/\/menu\/query/, 'post', menu.query);
//
// //角色
// Mock.mock(/\/role\/query/, 'post', role.query);

//版本管理
//Mock.mock(/\/version\/queryVersionIntents/, 'post',version.queryVersionIntents);

//意图
// Mock.mock(/\/intent\/queryIntentGrammar/, 'post',intent.queryIntentGrammar);
// Mock.mock(/\/intent\/saveIntentGrammar/, 'post',intent.saveIntentGrammar);

export default Mock



// WEBPACK FOOTER //
// ./src/mock/index.js